module.exports = __webpack_public_path__ + "static/kimaimesuive-8d72f9270fbc6d30eb711e2894936a76.png";